module.exports = __webpack_public_path__ + "static/media/sv_sc.5ae45300.png";